import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _SidebarSection;
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { bind } from "discourse-common/utils/decorators";
import DropdownSelectBox from "select-kit/components/dropdown-select-box";
import DTooltip from "float-kit/components/d-tooltip";
import SectionHeader from "./section-header";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let SidebarSection = (_class = (_SidebarSection = class SidebarSection extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "keyValueStore", _descriptor, this);
    _initializerDefineProperty(this, "sidebarState", _descriptor2, this);
    _defineProperty(this, "sidebarSectionContentID", `sidebar-section-content-${this.args.sectionName}`);
    _defineProperty(this, "collapsedSidebarSectionKey", `sidebar-section-${this.args.sectionName}-collapsed`);
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.args.willDestroy?.();
  }
  get isCollapsed() {
    if (!this.args.collapsable) {
      return false;
    }
    if (this.keyValueStore.getItem(this.collapsedSidebarSectionKey) === undefined) {
      return this.args.collapsedByDefault;
    }
    return this.keyValueStore.getItem(this.collapsedSidebarSectionKey) === "true";
  }
  setExpandedState() {
    if (!isEmpty(this.sidebarState.filter)) {
      return;
    }
    if (this.isCollapsed) {
      this.sidebarState.collapseSection(this.args.sectionName);
    } else {
      this.sidebarState.expandSection(this.args.sectionName);
    }
  }
  get displaySectionContent() {
    if (!isEmpty(this.sidebarState.filter)) {
      return true;
    }
    return !this.sidebarState.collapsedSections.has(this.collapsedSidebarSectionKey);
  }
  toggleSectionDisplay() {
    if (this.displaySectionContent) {
      this.sidebarState.collapseSection(this.args.sectionName);
    } else {
      this.sidebarState.expandSection(this.args.sectionName);
    }
    // remove focus from the toggle, but only on click
    if (!event.key) {
      document.activeElement.blur();
    }
  }
  handleMultipleHeaderActions(id1) {
    this.args.headerActions.find(headerAction1 => headerAction1.id === id1).action();
  }
  get headerCaretIcon() {
    return this.displaySectionContent ? "angle-down" : "angle-right";
  }
  get isSingleHeaderAction() {
    return this.args.headerActions?.length === 1;
  }
  get isMultipleHeaderActions() {
    return this.args.headerActions?.length > 1;
  }
  get displaySection() {
    if (this.args.displaySection === undefined) {
      return true;
    }
    return this.args.displaySection;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    {{#if this.displaySection}}
      <div
        {{didInsert this.setExpandedState}}
        data-section-name={{@sectionName}}
        class="sidebar-section-wrapper sidebar-section"
        ...attributes
      >
        {{#unless @hideSectionHeader}}
          <div class="sidebar-section-header-wrapper sidebar-row">
            <SectionHeader
              @collapsable={{@collapsable}}
              @sidebarSectionContentID={{this.sidebarSectionContentID}}
              @toggleSectionDisplay={{this.toggleSectionDisplay}}
              @isExpanded={{this.displaySectionContent}}
            >
              {{#if @collapsable}}
                <span class="sidebar-section-header-caret">
                  {{icon this.headerCaretIcon}}
                </span>
              {{/if}}

              <span class="sidebar-section-header-text">
                {{@headerLinkText}}
              </span>

              {{#if @indicatePublic}}
                <DTooltip
                  @icon="globe"
                  class="sidebar-section-header-global-indicator"
                >
                  <span
                    class="sidebar-section-header-global-indicator__content"
                  >
                    {{icon "shield-alt"}}
                    {{i18n "sidebar.sections.global_section"}}
                  </span>
                </DTooltip>
              {{/if}}
            </SectionHeader>

            {{#if this.isSingleHeaderAction}}
              {{#each @headerActions as |headerAction|}}
                <button
                  {{on "click" headerAction.action}}
                  type="button"
                  title={{headerAction.title}}
                  class="sidebar-section-header-button"
                >
                  {{icon @headerActionsIcon}}
                </button>
              {{/each}}
            {{/if}}

            {{#if this.isMultipleHeaderActions}}
              <DropdownSelectBox
                @options={{hash
                  icon=@headerActionsIcon
                  placementStrategy="absolute"
                }}
                @content={{@headerActions}}
                @onChange={{this.handleMultipleHeaderActions}}
                class="sidebar-section-header-dropdown"
              />
            {{/if}}
          </div>
        {{/unless}}

        {{#if this.displaySectionContent}}
          <ul
            id={{this.sidebarSectionContentID}}
            class="sidebar-section-content"
          >
            {{yield}}
          </ul>
        {{/if}}
      </div>
    {{/if}}
  
*/
{
  "id": "vkvMo+OG",
  "block": "[[[1,\"\\n\"],[41,[30,0,[\"displaySection\"]],[[[1,\"      \"],[11,0],[16,\"data-section-name\",[30,1]],[24,0,\"sidebar-section-wrapper sidebar-section\"],[17,2],[4,[32,0],[[30,0,[\"setExpandedState\"]]],null],[12],[1,\"\\n\"],[41,[51,[30,3]],[[[1,\"          \"],[10,0],[14,0,\"sidebar-section-header-wrapper sidebar-row\"],[12],[1,\"\\n            \"],[8,[32,1],null,[[\"@collapsable\",\"@sidebarSectionContentID\",\"@toggleSectionDisplay\",\"@isExpanded\"],[[30,4],[30,0,[\"sidebarSectionContentID\"]],[30,0,[\"toggleSectionDisplay\"]],[30,0,[\"displaySectionContent\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,4],[[[1,\"                \"],[10,1],[14,0,\"sidebar-section-header-caret\"],[12],[1,\"\\n                  \"],[1,[28,[32,2],[[30,0,[\"headerCaretIcon\"]]],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n              \"],[10,1],[14,0,\"sidebar-section-header-text\"],[12],[1,\"\\n                \"],[1,[30,5]],[1,\"\\n              \"],[13],[1,\"\\n\\n\"],[41,[30,6],[[[1,\"                \"],[8,[32,3],[[24,0,\"sidebar-section-header-global-indicator\"]],[[\"@icon\"],[\"globe\"]],[[\"default\"],[[[[1,\"\\n                  \"],[10,1],[14,0,\"sidebar-section-header-global-indicator__content\"],[12],[1,\"\\n                    \"],[1,[28,[32,2],[\"shield-alt\"],null]],[1,\"\\n                    \"],[1,[28,[32,4],[\"sidebar.sections.global_section\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"            \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"isSingleHeaderAction\"]],[[[42,[28,[31,3],[[28,[31,3],[[30,7]],null]],null],null,[[[1,\"                \"],[11,\"button\"],[16,\"title\",[30,8,[\"title\"]]],[24,0,\"sidebar-section-header-button\"],[24,4,\"button\"],[4,[32,5],[\"click\",[30,8,[\"action\"]]],null],[12],[1,\"\\n                  \"],[1,[28,[32,2],[[30,9]],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[8]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isMultipleHeaderActions\"]],[[[1,\"              \"],[8,[32,6],[[24,0,\"sidebar-section-header-dropdown\"]],[[\"@options\",\"@content\",\"@onChange\"],[[28,[32,7],null,[[\"icon\",\"placementStrategy\"],[[30,9],\"absolute\"]]],[30,7],[30,0,[\"handleMultipleHeaderActions\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"displaySectionContent\"]],[[[1,\"          \"],[10,\"ul\"],[15,1,[30,0,[\"sidebarSectionContentID\"]]],[14,0,\"sidebar-section-content\"],[12],[1,\"\\n            \"],[18,10,null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@sectionName\",\"&attrs\",\"@hideSectionHeader\",\"@collapsable\",\"@headerLinkText\",\"@indicatePublic\",\"@headerActions\",\"headerAction\",\"@headerActionsIcon\",\"&default\"],false,[\"if\",\"unless\",\"each\",\"-track-array\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/section.js",
  "scope": () => [didInsert, SectionHeader, icon, DTooltip, i18n, on, DropdownSelectBox, hash],
  "isStrictMode": true
}), _SidebarSection), _SidebarSection), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "keyValueStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sidebarState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setExpandedState", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "setExpandedState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSectionDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSectionDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMultipleHeaderActions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMultipleHeaderActions"), _class.prototype)), _class);
export { SidebarSection as default };